export const heroData = {
  tag: "海量资源 · 每日更新 · 全免费",
  slogan: "不缓冲 · 超清画质 · 流畅播放",
  intro: "6080影视是国内领先的免费电视剧在线播放平台，收录超过两万部海内外电视剧全集，涵盖国产剧、港剧、韩剧、日剧、美剧、泰剧等全品类。每日同步更新最新热播剧集，采用高速CDN加速技术，确保高清画质下流畅不缓冲的观影体验，无论是经典老剧还是热门新剧都能在这里免费在线观看全集。",
  intro2: "当前平台热播《长相思第二季》《唐朝诡事录之西行》《你比星光美丽》等话题剧集，同时完整收录《甄嬛传》《琅琊榜》《武林外传》等永不褪色的经典，每日更新量超过百集，覆盖各类题材满足不同观众口味。",
  stats: [
    { value: "20000+", label: "电视剧资源" },
    { value: "每日百集", label: "同步更新" },
    { value: "1080P", label: "超清画质" },
  ],
  cta1: { text: "立即追剧", href: "#cards" },
  cta2: { text: "热门榜单", href: "#ranking" },
};

export const mediaCards = [
  {
    id: 1,
    title: "长相思第二季",
    tag: "热播中",
    desc: "杨紫、张晚意领衔主演古装神话剧，续写大荒世界爱恨纠葛",
    views: "8.2亿次播放",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20costumes%20and%20ethereal%20lighting%2C%20cinematic%20warm%20golden%20tones%2C%20misty%20mountain%20background%2C%20professional%20film%20poster%20style%2C%20soft%20dramatic%20lighting%2C%20elegant%20composition&width=640&height=360&seq=media-card-01&orientation=landscape",
  },
  {
    id: 2,
    title: "唐朝诡事录之西行",
    tag: "热播中",
    desc: "古装悬疑探案剧，原班人马再度集结西域奇案",
    views: "5.6亿次播放",
    image: "https://readdy.ai/api/search-image?query=Tang%20Dynasty%20mystery%20detective%20drama%20poster%20with%20ancient%20Chinese%20architecture%20and%20lanterns%2C%20dark%20atmospheric%20cinematic%20lighting%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20professional%20film%20poster%20style&width=640&height=360&seq=media-card-02&orientation=landscape",
  },
  {
    id: 3,
    title: "你比星光美丽",
    tag: "热播中",
    desc: "谭松韵、许凯演绎都市职场浪漫爱情，甜度拉满",
    views: "4.1亿次播放",
    image: "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20poster%20with%20city%20night%20skyline%20and%20warm%20golden%20light%2C%20two%20characters%20in%20fashionable%20attire%2C%20cinematic%20depth%20of%20field%2C%20romantic%20atmosphere%2C%20professional%20film%20poster%20style&width=640&height=360&seq=media-card-03&orientation=landscape",
  },
  {
    id: 4,
    title: "庆余年第二季",
    tag: "已完结",
    desc: "张若昀领衔古装权谋大戏，范闲归来再掀风云",
    views: "12.3亿次播放",
    image: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20political%20drama%20poster%20with%20palace%20architecture%20and%20flowing%20robes%2C%20dramatic%20golden%20hour%20lighting%2C%20misty%20atmosphere%2C%20cinematic%20composition%2C%20professional%20film%20poster%20style&width=640&height=360&seq=media-card-04&orientation=landscape",
  },
  {
    id: 5,
    title: "墨雨云间",
    tag: "已完结",
    desc: "吴谨言古装复仇爽剧，高燃剧情全程无尿点",
    views: "7.8亿次播放",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20revenge%20drama%20poster%20with%20rain%20and%20ink%20wash%20aesthetic%2C%20dramatic%20contrast%20lighting%2C%20traditional%20hanfu%20costume%2C%20dark%20and%20warm%20tones%2C%20cinematic%20composition%2C%20professional%20film%20poster&width=640&height=360&seq=media-card-05&orientation=landscape",
  },
];

export const appEntry = {
  title: "手机看剧更便捷",
  subtitle: "6080影视移动端",
  desc: "支持iOS与Android双平台，随时随地畅享海量免费电视剧。极速加载、省流模式、夜间护眼、投屏观看，让追剧不再受场景限制。扫码下载或在应用商店搜索「6080影视」即可安装。",
  features: ["极速加载", "省流模式", "夜间护眼", "投屏观看"],
  image: "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20Chinese%20drama%20streaming%20app%20interface%20on%20screen%2C%20modern%20mobile%20UI%20with%20video%20thumbnails%2C%20held%20in%20hand%20against%20warm%20ambient%20background%2C%20soft%20lighting%2C%20clean%20product%20photography%20style&width=600&height=800&seq=app-mockup-01&orientation=portrait",
};

export const updates = [
  {
    id: 1,
    date: "2026-07-31",
    tag: "今日更新",
    title: "《长相思第二季》第28-30集上线，小夭身世之谜揭晓",
  },
  {
    id: 2,
    date: "2026-07-31",
    tag: "今日更新",
    title: "《唐朝诡事录之西行》更新至第24集，新案件「敦煌壁画」篇开启",
  },
  {
    id: 3,
    date: "2026-07-30",
    tag: "昨日更新",
    title: "《你比星光美丽》第18-19集，纪星与韩廷职场对决升级",
  },
  {
    id: 4,
    date: "2026-07-30",
    tag: "新剧上线",
    title: "都市题材新剧《三十九二十八》全集上线，聚焦保险行业职场人生",
  },
  {
    id: 5,
    date: "2026-07-29",
    tag: "经典回归",
    title: "《甄嬛传》76集4K修复版上线，经典永不褪色",
  },
  {
    id: 6,
    date: "2026-07-29",
    tag: "新剧上线",
    title: "日剧《重启人生》全集上线，豆瓣9.4分神作免费看",
  },
  {
    id: 7,
    date: "2026-07-28",
    tag: "片库更新",
    title: "本周新增韩剧《背着善宰跑》、美剧《幕府将军》等12部海外剧集",
  },
];

export const rankingItems = [
  {
    rank: 1,
    title: "长相思第二季",
    hot: "热度 9867",
    genre: "古装 / 神话 / 爱情",
    trend: "up",
  },
  {
    rank: 2,
    title: "唐朝诡事录之西行",
    hot: "热度 9123",
    genre: "古装 / 悬疑 / 探案",
    trend: "up",
  },
  {
    rank: 3,
    title: "你比星光美丽",
    hot: "热度 8745",
    genre: "都市 / 职场 / 爱情",
    trend: "up",
  },
  {
    rank: 4,
    title: "庆余年第二季",
    hot: "热度 8501",
    genre: "古装 / 权谋 / 喜剧",
    trend: "stable",
  },
  {
    rank: 5,
    title: "墨雨云间",
    hot: "热度 7932",
    genre: "古装 / 复仇 / 爽剧",
    trend: "stable",
  },
  {
    rank: 6,
    title: "玫瑰的故事",
    hot: "热度 7560",
    genre: "都市 / 情感 / 成长",
    trend: "up",
  },
];

export const features = [
  {
    id: 1,
    icon: "ri-speed-up-line",
    title: "秒加载不缓冲",
    desc: "采用全网领先的CDN加速与智能转码技术，无论宽带还是移动网络，点击即可流畅播放，告别缓冲等待，追剧体验一气呵成。",
  },
  {
    id: 2,
    icon: "ri-4k-line",
    title: "超清画质免费看",
    desc: "全站电视剧支持1080P超清画质播放，部分热门剧集提供4K版本，且全部免费无需会员，真正实现高清自由。",
  },
  {
    id: 3,
    icon: "ri-refresh-line",
    title: "每日更新不间断",
    desc: "编辑团队7×24小时同步各大平台更新，热播剧集上线后最快30分钟内即可在6080影视免费观看，追剧快人一步。",
  },
];

export const carouselItems = [
  {
    id: 1,
    title: "古装巨制 · 视觉盛宴",
    subtitle: "精选国产古装高分剧集",
    desc: "从《甄嬛传》的宫廷权谋到《琅琊榜》的家国情怀，从《长安十二时辰》的盛唐气象到《庆余年》的奇谋妙计——6080影视完整收录国产古装剧经典与热门，高清画质还原每一帧匠心制作。",
    image: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20scene%20with%20ancient%20palace%20and%20flowing%20hanfu%20costumes%2C%20dramatic%20golden%20sunset%20lighting%20through%20traditional%20architecture%2C%20cinematic%20widescreen%20composition%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20atmospheric%20mist&width=1200&height=600&seq=carousel-01&orientation=landscape",
  },
  {
    id: 2,
    title: "都市情感 · 贴近生活",
    subtitle: "热播都市剧一网打尽",
    desc: "职场奋斗、甜蜜爱恋、家庭温情——都市题材剧集记录当代中国人的情感与梦想。《你比星光美丽》《玫瑰的故事》《三十九二十八》等热剧持续更新，陪你感受都市生活的每一面。",
    image: "https://readdy.ai/api/search-image?query=Modern%20city%20nightscape%20with%20warm%20apartment%20interior%20lighting%2C%20cozy%20contemporary%20living%20scene%2C%20cinematic%20depth%20of%20field%2C%20warm%20golden%20and%20amber%20lighting%2C%20professional%20cinematography%20style%2C%20urban%20romance%20atmosphere&width=1200&height=600&seq=carousel-02&orientation=landscape",
  },
  {
    id: 3,
    title: "悬疑探案 · 烧脑不断",
    subtitle: "高分悬疑剧集专区",
    desc: "从《唐朝诡事录》的志怪奇案到《沉默的真相》的社会派推理，从《白夜追凶》的双胞胎谜局到《隐秘的角落》的人性拷问——6080影视悬疑剧专区汇聚国产悬疑巅峰之作，每一部都值得反复品味。",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20detective%20drama%20scene%20with%20rain-slicked%20alley%20and%20warm%20lantern%20glow%2C%20noir%20cinematic%20lighting%2C%20deep%20shadows%20and%20amber%20highlights%2C%20atmospheric%20fog%2C%20professional%20film%20noir%20style%2C%20suspenseful%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape",
  },
  {
    id: 4,
    title: "海外精选 · 全球热剧",
    subtitle: "韩日美泰剧集合集",
    desc: "不止国产好剧——6080影视同步收录韩剧、日剧、美剧、泰剧等海外热门剧集。《背着善宰跑》《幕府将军》《重启人生》等高分海外剧均提供官方中文字幕，让你足不出户看遍全球好剧。",
    image: "https://readdy.ai/api/search-image?query=Global%20television%20drama%20collage%20atmosphere%20with%20warm%20cinematic%20glow%2C%20international%20film%20poster%20aesthetic%2C%20soft%20dramatic%20lighting%2C%20warm%20golden%20and%20deep%20tones%2C%20professional%20cinematography%20style%2C%20elegant%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape",
  },
];

export const cardItems = [
  {
    id: 1,
    title: "甄嬛传",
    tag: "经典必看",
    genre: "古装 / 宫斗",
    desc: "孙俪、陈建斌主演清宫大戏，豆瓣9.4分，国产宫斗剧巅峰之作。76集4K修复版现已上线，每一帧都值得细品。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20imperial%20palace%20drama%20poster%20with%20elegant%20qing%20dynasty%20costume%20and%20palace%20interior%2C%20warm%20candlelit%20atmosphere%2C%20cinematic%20portrait%20composition%2C%20golden%20and%20amber%20tones%2C%20professional%20film%20poster%20style&width=600&height=400&seq=card-01&orientation=landscape",
  },
  {
    id: 2,
    title: "琅琊榜",
    tag: "豆瓣高分",
    genre: "古装 / 权谋",
    desc: "胡歌、刘涛领衔主演，豆瓣9.4分神作。金陵城内风云变幻，麒麟才子梅长苏复仇之路扣人心弦。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20mountain%20and%20misty%20landscape%2C%20traditional%20hanfu%20robes%20in%20wind%2C%20ethereal%20atmospheric%20lighting%2C%20warm%20golden%20hour%20tones%2C%20cinematic%20composition%2C%20professional%20film%20poster&width=600&height=400&seq=card-02&orientation=landscape",
  },
  {
    id: 3,
    title: "长安十二时辰",
    tag: "制作精良",
    genre: "古装 / 悬疑",
    desc: "雷佳音、易烊千玺主演，电影级制作还原盛唐长安。十二时辰内拯救长安的极限故事，全程高能无尿点。",
    image: "https://readdy.ai/api/search-image?query=Tang%20Dynasty%20cityscape%20with%20lanterns%20and%20ancient%20Chinese%20architecture%2C%20bustling%20street%20market%20atmosphere%2C%20warm%20golden%20lantern%20light%2C%20cinematic%20widescreen%20composition%2C%20professional%20film%20poster%20style&width=600&height=400&seq=card-03&orientation=landscape",
  },
  {
    id: 4,
    title: "狂飙",
    tag: "现象级热剧",
    genre: "剧情 / 犯罪",
    desc: "张译、张颂文主演年度爆款，扫黑除恶题材力作。高启强从鱼贩到黑老大的二十年人生沉浮，表演封神。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20urban%20night%20street%20and%20neon%20reflections%2C%20noir%20cinematic%20lighting%2C%20deep%20shadows%20with%20warm%20amber%20accents%2C%20professional%20film%20poster%20style%2C%20atmospheric%20tension&width=600&height=400&seq=card-04&orientation=landscape",
  },
  {
    id: 5,
    title: "白夜追凶",
    tag: "悬疑巅峰",
    genre: "悬疑 / 犯罪",
    desc: "潘粤明一人分饰两角，豆瓣9.0分国产悬疑神作。双胞胎兄弟白天黑夜交替查案，烧脑程度层层递进。",
    image: "https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20drama%20poster%20with%20split%20lighting%20half%20bright%20half%20shadow%2C%20noir%20cinematic%20style%2C%20urban%20night%20atmosphere%2C%20warm%20and%20cool%20contrast%20tones%2C%20professional%20film%20poster%20composition&width=600&height=400&seq=card-05&orientation=landscape",
  },
  {
    id: 6,
    title: "武林外传",
    tag: "童年回忆",
    genre: "喜剧 / 古装",
    desc: "闫妮、沙溢领衔，国产情景喜剧天花板。同福客栈里的嬉笑怒骂，80集笑到停不下来，看多少遍都不腻。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20ancient%20style%20inn%20interior%20with%20warm%20lantern%20light%2C%20cozy%20traditional%20tavern%20atmosphere%2C%20comedic%20warm%20lighting%2C%20golden%20and%20wood%20tones%2C%20professional%20film%20poster%20style%2C%20nostalgic%20feel&width=600&height=400&seq=card-06&orientation=landscape",
  },
  {
    id: 7,
    title: "三体",
    tag: "科幻巨制",
    genre: "科幻 / 剧情",
    desc: "刘慈欣原著改编，国产科幻剧集里程碑。纳米科学家汪淼与刑警史强联手揭开三体世界的神秘面纱。",
    image: "https://readdy.ai/api/search-image?query=Science%20fiction%20drama%20poster%20with%20cosmic%20and%20starry%20sky%20background%2C%20futuristic%20yet%20grounded%20aesthetic%2C%20warm%20golden%20light%20against%20deep%20space%2C%20cinematic%20composition%2C%20professional%20film%20poster%20style%2C%20mysterious%20atmosphere&width=600&height=400&seq=card-07&orientation=landscape",
  },
];

export const comments = [
  {
    id: 1,
    name: "追剧达人小王",
    date: "2026-07-28",
    rating: 5,
    content: "用了6080影视两年多了，资源真的很全，更新也快。之前追《庆余年第二季》的时候，基本上电视台播完半小时这里就有了，而且1080P画质完全免费，真的良心平台。",
    avatar: "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20young%20Asian%20person%2C%20soft%20natural%20lighting%2C%20friendly%20expression%2C%20simple%20warm%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish",
  },
  {
    id: 2,
    name: "深夜追剧人",
    date: "2026-07-27",
    rating: 5,
    content: "作为一个美剧迷，在这里找到了好多冷门好剧，而且都有中文字幕。最重要的是不卡顿，以前在别的站看老是缓冲，6080的播放体验真的好太多了。",
    avatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20Asian%20person%20with%20glasses%2C%20soft%20warm%20lighting%2C%20casual%20style%2C%20simple%20neutral%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish",
  },
  {
    id: 3,
    name: "剧荒拯救者",
    date: "2026-07-26",
    rating: 5,
    content: "推荐给了身边所有追剧的朋友！分类很清晰，想找什么类型的剧都能快速找到。最近刚在「经典必看」专区重温了《琅琊榜》，4K画质真的太震撼了。",
    avatar: "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20young%20Asian%20woman%2C%20soft%20natural%20lighting%2C%20gentle%20smile%2C%20simple%20warm%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-03&orientation=squarish",
  },
  {
    id: 4,
    name: "老剧收藏家",
    date: "2026-07-25",
    rating: 4,
    content: "这里的老剧资源真的太难得了！《大宅门》《康熙王朝》《汉武大帝》这些经典在别的平台都要会员才能看，6080全部免费，画质还修复得很好。希望继续保持！",
    avatar: "https://readdy.ai/api/search-image?query=Mature%20Asian%20person%20portrait%2C%20warm%20soft%20lighting%2C%20kind%20expression%2C%20simple%20neutral%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-04&orientation=squarish",
  },
  {
    id: 5,
    name: "韩剧爱好者",
    date: "2026-07-24",
    rating: 5,
    content: "韩剧更新速度和韩站同步！《背着善宰跑》全网首发的就是这里，翻译质量也很高。手机端看剧体验也很好，晚上开护眼模式追剧眼睛不累。",
    avatar: "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20Asian%20young%20adult%2C%20soft%20natural%20lighting%2C%20bright%20expression%2C%20simple%20warm%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-05&orientation=squarish",
  },
];

export const aboutData = {
  title: "关于6080影视",
  content: "6080影视成立于2018年，是国内领先的免费电视剧在线播放平台。我们致力于为观众提供海量、高清、不缓冲的电视剧观看体验，让每一个热爱追剧的人都能在这里找到属于自己的快乐。平台收录超过20000部海内外电视剧，涵盖国产剧、港剧、韩剧、日剧、美剧、泰剧等全品类，每日更新超过百集。",
  content2: "我们的技术团队持续优化播放体验，全网部署高速CDN节点，支持智能自适应码率，无论使用宽带还是移动网络，都能享受流畅的超清画质。6080影视始终坚持免费原则，所有内容均可免费在线观看，无需注册、无需会员、无需付费。",
  highlights: [
    { value: "20000+", label: "电视剧资源" },
    { value: "7年", label: "稳定运营" },
    { value: "100%", label: "完全免费" },
    { value: "1080P", label: "超清画质" },
  ],
};

export const faqItems = [
  {
    id: 1,
    question: "6080影视真的完全免费吗？需要注册或付费吗？",
    answer: "是的，6080影视所有电视剧均可免费在线观看，无需注册账号，无需付费开通会员，更不存在任何隐藏收费。我们通过广告收益维持平台运营，观众无需承担任何费用。",
  },
  {
    id: 2,
    question: "播放画质如何？支持哪些清晰度？",
    answer: "全站电视剧默认提供1080P超清画质播放，部分热门剧集支持4K分辨率。平台采用智能自适应码率技术，会根据您的网络状况自动调整最佳清晰度，确保流畅不卡顿的观看体验。",
  },
  {
    id: 3,
    question: "为什么在6080影视看剧不缓冲？",
    answer: "我们部署了覆盖全国的高速CDN加速网络，配合自研的智能转码与预加载技术，大幅缩短视频加载时间。同时采用P2P辅助传输方案，在保障画质的前提下最大化播放流畅度。",
  },
  {
    id: 4,
    question: "新剧更新速度快吗？会同步卫视播出吗？",
    answer: "编辑团队7×24小时实时监控各大平台更新动态，热播剧集在电视台播出后最快30分钟内即可上线。每日更新量超过百集，确保您追剧快人一步，不错过任何精彩内容。",
  },
  {
    id: 5,
    question: "支持手机和平板观看吗？可以投屏吗？",
    answer: "6080影视全面适配手机、平板、电脑等多种设备，网页端自动适配屏幕尺寸。同时支持DLNA和AirPlay投屏功能，您可以将正在观看的电视剧一键投射到电视大屏上，享受家庭影院级体验。",
  },
  {
    id: 6,
    question: "如果遇到播放问题该怎么办？",
    answer: "如遇到播放卡顿或无法加载的情况，建议先尝试切换线路（播放器底部提供多条备用线路）或刷新页面。如问题持续存在，可通过页面底部「联系我们」区域反馈问题，技术团队会尽快处理。",
  },
];

export const contactData = {
  title: "联系我们",
  subtitle: "意见反馈 · 资源建议 · 商务合作",
  desc: "如果您在使用过程中遇到任何问题，或有剧集资源建议、商务合作意向，欢迎通过以下方式与我们取得联系。我们珍视每一位用户的反馈，您的建议是我们不断进步的动力。",
  email: "feedback@6080ys.com",
  qq: "1234567890",
  wechat: "tv6080ys",
};

export const indexTopics = [
  { id: 1, title: "国产古装剧", count: 3280, icon: "ri-ancient-gate-line" },
  { id: 2, title: "都市情感剧", count: 2560, icon: "ri-building-line" },
  { id: 3, title: "悬疑探案剧", count: 1840, icon: "ri-search-eye-line" },
  { id: 4, title: "韩剧专区", count: 1520, icon: "ri-global-line" },
  { id: 5, title: "日剧专区", count: 980, icon: "ri-earth-line" },
  { id: 6, title: "美剧专区", count: 1340, icon: "ri-globe-line" },
  { id: 7, title: "经典老剧", count: 2150, icon: "ri-time-line" },
  { id: 8, title: "喜剧搞笑", count: 1670, icon: "ri-emotion-laugh-line" },
  { id: 9, title: "科幻奇幻", count: 890, icon: "ri-rocket-line" },
];

export const topicTags = [
  { id: 1, name: "长相思第二季", count: "128万讨论" },
  { id: 2, name: "唐朝诡事录", count: "96万讨论" },
  { id: 3, name: "古装剧推荐", count: "85万讨论" },
  { id: 4, name: "豆瓣高分剧", count: "73万讨论" },
  { id: 5, name: "韩剧推荐", count: "68万讨论" },
  { id: 6, name: "悬疑剧天花板", count: "61万讨论" },
  { id: 7, name: "都市剧推荐", count: "55万讨论" },
  { id: 8, name: "4K修复", count: "48万讨论" },
  { id: 9, name: "经典老剧重刷", count: "42万讨论" },
  { id: 10, name: "2026必看剧", count: "37万讨论" },
];

export const partnersData = {
  title: "合作伙伴",
  items: [],
};